<div class="container">
    <div class="row"> 
        <div class="col-md-12 py-4 ps-2">
        <!-- <p><span class="link-casestudy hoverable-link" routerLink="/">Home</span>/<span class="newsrouter hoverable-link" routerLink="/news-letters/newsletter">Newsletter</span></p> -->
          <p>
            <span class="link" (click)="goHome()">Home</span> / 
            <span class="newsrouter" (click)="goNewsLetter()">Newsletter</span>
          </p>
    </div>
     <div class="col-md-12">
        <img *ngIf="currentImagePath" [src]="currentImagePath" class="img-fluid" alt="Monthly Newsletter">
        </div>      
    </div>
</div>  